export const enSaaSBilling = {
  hero: {
    title: "Multi-Tenant SaaS Billing & Management System",
    subtitle: "A comprehensive platform for invoice management and payment processing with multi-company support",
    imageAlt: "SaaS billing dashboard showing invoice management"
  },
  features: {
    multiTenant: {
      title: "Multi-Tenant Architecture",
      description: "Support for multiple companies with isolated data and configurations"
    },
    invoiceManagement: {
      title: "Invoice Management",
      description: "Create, track, and manage invoices with automated reminders"
    },
    partialPayments: {
      title: "Partial Payments",
      description: "Flexible payment options with support for partial payments"
    },
    multiCurrency: {
      title: "Multi-Currency & Language",
      description: "Support for multiple currencies and languages for global businesses"
    },
    paymentGateways: {
      title: "Payment Gateway Integration",
      description: "Seamless integration with Stripe, PayPal and other payment processors"
    },
    roleBasedAccess: {
      title: "Role-Based Access",
      description: "Three-tier user roles: Super Admin, Admin, and Client with appropriate permissions"
    }
  },
  techStack: {
    title: "Technology Stack",
    backend: {
      title: "Backend",
      laravel: "Laravel (PHP) for robust backend operations",
      apiArchitecture: "API-first architecture for seamless integrations",
      multiTenant: "Built-in multi-tenant support"
    },
    frontend: {
      title: "Frontend",
      framework: "React.js with modern UI components",
      typescript: "TypeScript for type safety",
      responsive: "Fully responsive design system"
    },
    integrations: {
      title: "Integrations",
      payments: "Stripe, PayPal, and other payment processors",
      notifications: "Email and SMS notification systems",
      analytics: "Business analytics and reporting tools"
    }
  },
  dashboard: {
    title: "Powerful Billing Dashboard",
    description: "Complete control over your multi-tenant billing operations with our comprehensive admin panel.",
    demoAlt: "SaaS billing platform admin dashboard preview",
    features: {
      "1": "Real-time financial analytics",
      "2": "Multi-company management",
      "3": "Automated invoicing system",
      "4": "Client portal interface",
      "5": "Custom reporting tools"
    }
  },
  cta: {
    title: "Ready to Transform Your Billing Process?",
    description: "Our multi-tenant SaaS solution streamlines your invoicing and payment management across multiple companies.",
    buttonText: "View Demo",
    buttonAriaLabel: "View demo of the SaaS billing platform"
  }
};


export const frSaaSBilling = {
  hero: {
    title: "Système de facturation et de gestion SaaS multi-tenant",
    subtitle: "Une plateforme complète pour la gestion des factures et le traitement des paiements avec support multi-entreprises",
    imageAlt: "Tableau de bord de facturation SaaS montrant la gestion des factures"
  },
  features: {
    multiTenant: {
      title: "Architecture multi-tenant",
      description: "Support pour plusieurs entreprises avec des données et des configurations isolées"
    },
    invoiceManagement: {
      title: "Gestion des factures",
      description: "Créer, suivre et gérer les factures avec des rappels automatisés"
    },
    partialPayments: {
      title: "Paiements partiels",
      description: "Options de paiement flexibles avec support pour les paiements partiels"
    },
    multiCurrency: {
      title: "Multi-devises et langues",
      description: "Support pour plusieurs devises et langues pour les entreprises mondiales"
    },
    paymentGateways: {
      title: "Intégration des passerelles de paiement",
      description: "Intégration transparente avec Stripe, PayPal et d'autres processeurs de paiement"
    },
    roleBasedAccess: {
      title: "Contrôle d'accès basé sur les rôles",
      description: "Rôles d'utilisateur à trois niveaux : Super Admin, Admin et Client avec les autorisations appropriées"
    }
  },
  techStack: {
    title: "Technologie Stack",
    backend: {
      title: "Backend",
      laravel: "Laravel (PHP) pour des opérations backend robustes",
      apiArchitecture: "Architecture API-first pour des intégrations transparentes",
      multiTenant: "Support multi-tenant intégré"
    },
    frontend: {
      title: "Frontend",
      framework: "React.js avec des composants UI modernes",
      typescript: "TypeScript pour la sécurité des types",
      responsive: "Système de design entièrement responsive"
    },
    integrations: {
      title: "Intégrations",
      payments: "Stripe, PayPal et autres processeurs de paiement",
      notifications: "Systèmes de notification par e-mail et SMS",
      analytics: "Outils d'analyse et de reporting commercial"
    }
  },
  dashboard: {
    title: "Tableau de bord de facturation puissant",
    description: "Contrôle total de vos opérations de facturation multi-tenant avec notre panneau d'administration complet.",
    demoAlt: "Aperçu du tableau de bord administrateur de la plateforme de facturation SaaS",
    features: {
      "1": "Analytique financière en temps réel",
      "2": "Gestion multi-entreprises",
      "3": "Système de facturation automatisé",
      "4": "Interface du portail client",
      "5": "Outils de reporting personnalisés"
    }
  },
  cta: {
    title: "Prêt à transformer votre processus de facturation?",
    description: "Notre solution SaaS multi-tenant rationalise votre gestion des factures et des paiements à travers plusieurs entreprises.",
    buttonText: "Voir la démo",
    buttonAriaLabel: "Voir la démo de la plateforme de facturation SaaS"
  }
};

export const nlSaaSBilling = {
  hero: {
    title: "Multi-Tenant SaaS Facturatie- & Beheersysteem",
    subtitle: "Een uitgebreid platform voor factuurbeheer en betalingsverwerking met ondersteuning voor meerdere bedrijven",
    imageAlt: "SaaS facturatie dashboard toont factuurbeheer"
  },
  features: {
    multiTenant: {
      title: "Multi-Tenant Architectuur",
      description: "Ondersteuning voor meerdere bedrijven met geïsoleerde data en configuraties"
    },
    invoiceManagement: {
      title: "Factuurbeheer",
      description: "Facturen aanmaken, volgen en beheren met automatische herinneringen"
    },
    partialPayments: {
      title: "Deelbetalingen",
      description: "Flexibele betalingsopties met ondersteuning voor deelbetalingen"
    },
    multiCurrency: {
      title: "Multi-valuta & Taal",
      description: "Ondersteuning voor meerdere valuta en talen voor internationale bedrijven"
    },
    paymentGateways: {
      title: "Betalingsgateway-integratie",
      description: "Naadloze integratie met Stripe, PayPal en andere betalingsverwerkers"
    },
    roleBasedAccess: {
      title: "Rolgebaseerde Toegang",
      description: "Drie gebruikersrollen: Super Admin, Admin en Klant met passende rechten"
    }
  },
  techStack: {
    title: "Technologiestack",
    backend: {
      title: "Backend",
      laravel: "Laravel (PHP) voor robuuste backend-operaties",
      apiArchitecture: "API-first architectuur voor naadloze integraties",
      multiTenant: "Ingebouwde multi-tenant ondersteuning"
    },
    frontend: {
      title: "Frontend",
      framework: "React.js met moderne UI-componenten",
      typescript: "TypeScript voor typeveiligheid",
      responsive: "Volledig responsief designsysteem"
    },
    integrations: {
      title: "Integraties",
      payments: "Stripe, PayPal en andere betalingsverwerkers",
      notifications: "E-mail- en SMS-notificatiesystemen",
      analytics: "Business analytics en rapportagetools"
    }
  },
  dashboard: {
    title: "Krachtig Facturatie Dashboard",
    description: "Volledige controle over uw multi-tenant facturatie met ons uitgebreide adminpanel.",
    demoAlt: "Preview van SaaS facturatie admin dashboard",
    features: {
      "1": "Realtime financiële analytics",
      "2": "Multi-bedrijven beheer",
      "3": "Geautomatiseerd facturatiesysteem",
      "4": "Klantportaal interface",
      "5": "Aangepaste rapportagetools"
    }
  },
  cta: {
    title: "Klaar om uw facturatieproces te transformeren?",
    description: "Onze multi-tenant SaaS-oplossing stroomlijnt uw facturatie en betalingsbeheer voor meerdere bedrijven.",
    buttonText: "Bekijk Demo",
    buttonAriaLabel: "Bekijk demo van het SaaS facturatieplatform"
  }
};

export const deSaaSBilling = {
  hero: {
    title: "Multi-Tenant SaaS Abrechnungs- & Verwaltungssystem",
    subtitle: "Eine umfassende Plattform für Rechnungsmanagement und Zahlungsabwicklung mit Multi-Company-Unterstützung",
    imageAlt: "SaaS-Abrechnungs-Dashboard zeigt Rechnungsverwaltung"
  },
  features: {
    multiTenant: {
      title: "Multi-Tenant-Architektur",
      description: "Unterstützung für mehrere Unternehmen mit isolierten Daten und Konfigurationen"
    },
    invoiceManagement: {
      title: "Rechnungsmanagement",
      description: "Rechnungen erstellen, verfolgen und verwalten mit automatischen Erinnerungen"
    },
    partialPayments: {
      title: "Teilzahlungen",
      description: "Flexible Zahlungsoptionen mit Unterstützung für Teilzahlungen"
    },
    multiCurrency: {
      title: "Multi-Währung & Sprache",
      description: "Unterstützung für mehrere Währungen und Sprachen für globale Unternehmen"
    },
    paymentGateways: {
      title: "Zahlungsgateway-Integration",
      description: "Nahtlose Integration mit Stripe, PayPal und anderen Zahlungsanbietern"
    },
    roleBasedAccess: {
      title: "Rollenbasierter Zugriff",
      description: "Drei Benutzerrollen: Super Admin, Admin und Kunde mit entsprechenden Berechtigungen"
    }
  },
  techStack: {
    title: "Technologie-Stack",
    backend: {
      title: "Backend",
      laravel: "Laravel (PHP) für robuste Backend-Operationen",
      apiArchitecture: "API-First-Architektur für nahtlose Integrationen",
      multiTenant: "Integrierte Multi-Tenant-Unterstützung"
    },
    frontend: {
      title: "Frontend",
      framework: "React.js mit modernen UI-Komponenten",
      typescript: "TypeScript für Typsicherheit",
      responsive: "Vollständig responsives Designsystem"
    },
    integrations: {
      title: "Integrationen",
      payments: "Stripe, PayPal und andere Zahlungsanbieter",
      notifications: "E-Mail- und SMS-Benachrichtigungssysteme",
      analytics: "Business Analytics und Reporting-Tools"
    }
  },
  dashboard: {
    title: "Leistungsstarkes Abrechnungs-Dashboard",
    description: "Vollständige Kontrolle über Ihre Multi-Tenant-Abrechnungsprozesse mit unserem umfassenden Admin-Panel.",
    demoAlt: "Vorschau des SaaS-Abrechnungs-Admin-Dashboards",
    features: {
      "1": "Echtzeit-Finanzanalytik",
      "2": "Multi-Company-Management",
      "3": "Automatisiertes Rechnungssystem",
      "4": "Kundenportal-Oberfläche",
      "5": "Individuelle Reporting-Tools"
    }
  },
  cta: {
    title: "Bereit, Ihren Abrechnungsprozess zu transformieren?",
    description: "Unsere Multi-Tenant-SaaS-Lösung optimiert Ihr Rechnungs- und Zahlungsmanagement für mehrere Unternehmen.",
    buttonText: "Demo ansehen",
    buttonAriaLabel: "Demo der SaaS-Abrechnungsplattform ansehen"
  }
};
